<app-header [navClass]="addclass"></app-header>

<router-outlet (activate)="onActivate($event)"></router-outlet>

<app-footer></app-footer>
